/* Hearts and sparkles burst on button hover (matches sprinkle rain). */

import { SPARKLE_PATH } from "./sprinkle-rain.js?v=20261007m";

const SHAPES = ["heart", "sparkle"];
const SPRINKLE_MS = 800;

function shapeSvg(type, color) {
  if (type === "heart") {
    return `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="${color}" d="M12 20s-7-4.5-9.5-9A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 9.5 5c-2.5 4.5-9.5 9-9.5 9Z"/></svg>`;
  }
  return `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="${color}" d="${SPARKLE_PATH}"/></svg>`;
}

export function clearButtonSprinkles() {
  document.querySelectorAll(".btn-sprinkle").forEach((el) => el.remove());
}

function spawnBurst(btn) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (window.matchMedia("(hover: none)").matches) return;
  if (document.hidden) return;

  const colors = [
    "var(--accent)",
    "var(--accent-deep)",
    "var(--secondary)",
    "var(--secondary-deep)",
  ];
  const rect = btn.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) return;

  const n = window.matchMedia("(max-width: 720px)").matches ? 3 : 5;
  for (let i = 0; i < n; i++) {
    const el = document.createElement("span");
    el.className = "btn-sprinkle";
    const type = SHAPES[i % SHAPES.length];
    el.innerHTML = shapeSvg(type, colors[i % colors.length]);
    const x = rect.left + rect.width * (0.2 + Math.random() * 0.6);
    const y = rect.top + rect.height * (0.15 + Math.random() * 0.5);
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
    el.style.setProperty("--dx", `${-24 + Math.random() * 48}px`);
    el.style.setProperty("--dy", `${-36 - Math.random() * 28}px`);
    el.style.setProperty("--rot", `${-40 + Math.random() * 80}deg`);
    document.body.appendChild(el);
    const remove = () => el.remove();
    el.addEventListener("animationend", remove, { once: true });
    el.addEventListener("animationcancel", remove, { once: true });
    // Turbo / tab switches can skip animationend and leave fixed 12px flecks on the page.
    window.setTimeout(remove, SPRINKLE_MS);
  }
}

let cleanupWired = false;

export function initButtonSprinkle(root = document) {
  root.querySelectorAll(".btn--primary, .btn--accent, .btn.btn--primary").forEach((btn) => {
    if (btn.dataset.sprinkleWired === "1") return;
    btn.dataset.sprinkleWired = "1";
    btn.addEventListener("mouseenter", () => spawnBurst(btn));
  });

  if (!cleanupWired) {
    cleanupWired = true;
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) clearButtonSprinkles();
    });
    window.addEventListener("pagehide", clearButtonSprinkles);
  }
}
